import React from 'react';
import {connect} from 'react-redux';

import {Close} from '../close/Close';

import './about.css';

const mapUrl = [
  'https://www.google.com/maps/embed?',
  'pb=!1m18!1m12!1m3!1d2374.8778007486458!2d-2.2393849845247105!3d53.470643980005256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!',
  '4f13.1!3m3!1m2!1s0x487bb1933387cdbd%3A0x44d9c4c9e7561f1c!2sRed+Sea+Tattoo!5e0!3m2!1sen!2suk!4v1480989725786',
].join('');

export const AboutComponent = () => {
  return (
    <div className="page about">
      <Close target='/'/>
      <div className="width-restrict">
        <section className="about-section intro-container">
          <h1>My Studio</h1>
          <p>One of the longest running tattoo studios in Manchester. I founded Red Sea Tattoo at 127a Oxford Road in
            1999, and have worked here ever since.</p>
          <p>The studio is close to the City Centre, in the university district, away from the hustle and bustle. The
            vibe
            is all about Calm and Focus.</p>
          <p>After completing my Art Degree at Manchester Metropolitan University. Did I think I would be making my
            artist
            home in an Attic on Oxford Road? For so many years? Nope, but it has been great. Thank goodness for
            Skylights!</p>
          <p>Since the beginning I have proudly brought to life Thousands of tattoo ideas, and met so many Fun,
            Interesting and Diverse folks. Year in and year out.</p>
          <p>I have been lucky enough to go Full Coverage on some. As well as doing the one little tattoo they always
            wanted on others. And a whole lot of everything in between too.</p>
          <p>So if you have an idea for a new tattoo drop by for a chat. And see what I could do with that idea.
            Consultation chats are Free and without obligation.</p>
        </section>

        <section className="about-section consultations-container">
          <h2>Consultations</h2>
          <p>The First Step To Making An Appointment</p>
          <p>With a Free consultation we can make sure we get the most out of your idea. Hear all you have to say. See
            all
            the images that have inspired you. Consider all the possibilities. Then we sketch on skin to guarantee the
            tattoo will Fit the Body. And that we are on the same page.</p>
          <p>Consultations are the key to great tattoos. And all tattoos should aim to be great.</p>
          <p>That is why I set aside so many hours every week to be available to talk Face to Face. Everyone should chat
            directly with a tattoo artist before considering making an appointment.</p>
          <p>A full consultation is essential to being able to quote for any tattoo. I can’t quote without one. So don’t
            ask me to...</p>
        </section>

        <div className="two-col">
          <section className="about-section cold-facts-container">
            <h2>Cold hard facts</h2>
            <ul>
              <li>Bespoke Custom Tattoo Studio.</li>
              <li>Fully Health registered.</li>
              <li>Appointments available 5 days a week, Tuesday Wednesday Thursday Friday Saturday, from 12pm to 8pm.
              </li>
              <li>Free Drop in Consultations<br />
                11am-12pm every morning Tuesday though Saturday<br />
                and 11am to 3pm on Fridays<br />
                or by arrangement
              </li>
              <li>All design work is free.</li>
              <li>Deposits are required to make an Appointment.</li>
              <li>These are fully refundable with 48 hours notice.</li>
              <li>Cover ups, Extensions and Reworks happily considered.</li>
              <li>Full Body tattooing for men and women.</li>
              <li>Full Privacy available as required.</li>
              <li>All Skin Types and Skin Tones.</li>
              <li>You must be 18 or over to have a tattoo.</li>
            </ul>
          </section>

          <section className="about-section map-container">
            <h2>Finding the studio</h2>
            <iframe className="map" src={mapUrl} frameBorder="0"/>
          </section>
        </div>
        <section className="about-section connect-container">
          <h2>Connect</h2>
          <h3><a href="tel: 07947 884934" title="Telephone 07947 884934">07947 884934</a></h3>
          <h3><a href="mailto: laurence@redseatattoo.co.uk" title="Email Laurence">laurence@redseatattoo.co.uk</a></h3>
          <h3>Red Sea Tattoo, 127a Oxford Road, Manchester, M1 7DY</h3>
          <ul className="social-links">
            <li className="social-links--item">
              <a href="https://www.facebook.com/Red-Sea-Tattoo-184956601523219/" title="Visit Facebook"
                 className="social-link social-link--facebook">Facebook</a>
            </li>
            <li className="social-links--item">
              <a href="https://www.instagram.com/redseatattoomcr/" title="Visit Instagram"
                 className="social-link social-link--instagram">Instagram</a>
            </li>
            <li className="social-links--item">
              <a href="http://redseatattoomcr.tumblr.com/" title="Visit Tumblr"
                 className="social-link social-link--tumblr">Tumblr</a>
            </li>
            <li className="social-links--item">
              <a href="tel: 07947 884934" title="Telephone 07947 884934" className="social-link social-link--tel">Telephone</a>
            </li>
            <li className="social-links--item">
              <a href="mailto: laurence@redseatattoo.co.uk" title="Email"
                 className="social-link social-link--email">Email</a>
            </li>
          </ul>
        </section>
        <div className="game-over"/>
      </div>
    </div>
  );
};

AboutComponent.displayName = 'About';

const mapStateToProps = (state, ownProps) => ({});

export const About = connect(mapStateToProps, {})(AboutComponent);


// WEBPACK FOOTER //
// ./src/components/about/About.js